import { render } from "./InvitesMenu.vue?vue&type=template&id=a17dca74&scoped=true"
import script from "./InvitesMenu.vue?vue&type=script&lang=js"
export * from "./InvitesMenu.vue?vue&type=script&lang=js"

import "./InvitesMenu.vue?vue&type=style&index=0&id=a17dca74&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a17dca74"]])

export default __exports__